import React, { useRef, useState } from 'react';
import './Faq.css';

const FAQS = [
  { q: 'How quickly can we start?', a: 'Most engagements kick off within a week of the scoping call, sooner for focused, well-defined work.' },
  { q: 'Do you work fixed-scope or ongoing?', a: 'Both. We take on one-off builds as well as ongoing product and growth retainers, whichever fits your stage.' },
  { q: 'Who owns the code and accounts?', a: 'You do: your repo, your CRM portal, and your ad accounts from day one. No lock-in, ever.' },
  { q: 'Can you take over an existing project?', a: 'Yes. We audit what is already there and improve from your current baseline instead of starting from scratch.' },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq" id="faq">
      <div className="faq-inner">
        <div className="faq-heading">
          <h2 data-reveal>Questions, answered</h2>
          <div className="faq-eyebrow" data-reveal>FAQ</div>
        </div>
        <div className="faq-list">
          {FAQS.map((f, index) => (
            <FaqItem
              key={f.q}
              faq={f}
              isOpen={index === openIndex}
              onToggle={() => setOpenIndex(index === openIndex ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqItem({ faq, isOpen, onToggle }) {
  const bodyRef = useRef(null);

  return (
    <div className="faq-item" data-open={isOpen || undefined} data-reveal>
      <button type="button" className="faq-item-head" onClick={onToggle} aria-expanded={isOpen}>
        <span className="faq-item-q">{faq.q}</span>
        <span className="faq-item-icon">+</span>
      </button>
      <div
        className="faq-item-body"
        ref={bodyRef}
        style={{ maxHeight: isOpen ? `${bodyRef.current?.scrollHeight ?? 200}px` : '0px' }}
      >
        <div className="faq-item-a">{faq.a}</div>
      </div>
    </div>
  );
}
